export default __webpack_public_path__ + "e8d4e06854d65dde94e049151fb257fa.png";